<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="mb-0">
                    <i class="fa fa-fw fa-archive mr-2" />
                    {{ data.status == 1 ? "Draft Flash Sale" : "Detail Flash Sale" }}
                </h5>
                <div>
                    Status :
                    <b-badge :variant="getStatusBadge(data.status)[0]">
                        {{ getStatusBadge(data.status)[1] }}
                    </b-badge>
                </div>
            </div>
            <hr />
            <b-row>
                <b-col md="6">
                    Nama Flash Sale: <strong> {{ data.name }}</strong><br />
                    <div style="max-width: 400px; word-break: break-word;">
                        Deskripsi: <strong>{{ data.description }}</strong><br />
                    </div>
                    Gudang <strong>{{ data.warehouse }} - {{ data.office }}</strong><br />
                    Group <strong>{{ data.group_name === null ? '-' : data.group_name }}</strong><br />
                    Divisi barang <strong>{{ data.division }}</strong><br />
                    <div v-if="data.discount_percentage">
                        Diskon Flash Sale: <strong>{{ data.discount_percentage }}%</strong>
                    </div>
                    Total <strong>{{ data.total_item }}</strong> barang <br />
                    Total Harga <strong>Rp.{{ $helper.formatThousand(data.total_price) }}</strong>
                </b-col>
                <b-col md="6" class="text-right">
                    <div v-if="data.status == 1">
                        <b-button variant="danger" @click="cancelFlashSale">
                            <i class="fa fa-times mr-2" />Batalkan
                        </b-button>
                        <b-button variant="success" class="ml-2" @click="activatedFlashSale">
                            <i class="fa fa-check mr-2" />Aktivasi Flash Sale
                        </b-button>
                    </div>
                    <div v-if="data.status == 2">
                        <b-button :disabled="isSubmitting" variant="warning" @click="nonActiveFlashSale">
                            <i class="fa fa-power-off mr-2" />
                            Nonaktifkan Flash Sale
                        </b-button>
                        <b-button variant="success" class="ml-2" @click="openModalFinalize">
                            <i class="fa fa-check mr-2" />Transaksikan Flash Sale
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-3" v-if="data.status == 1">
                <b-col md="6">
                    <b-input-group>
                        <b-input v-model="input.noFaktur" maxlength="100" style="max-width: 250px"
                            placeholder="Input No. Faktur..." @keydown.enter="getItem" />
                        <b-input-group-append>
                            <b-button variant="dark" @click="getItem" :disabled="isEditing">Tambah Barang</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting :items="data.items" :fields="filteredFields"
                :busy="isBusy" responsive class="my-3" @sort-changed="onSortChanged">
                <template v-slot:empty>
                    Belum ada barang di flash sale.
                </template>
                <template v-slot:cell(no)="row">
                    {{ row.index + 1 }}.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }}
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="danger" v-b-tooltip.hover.top title="Hapus" :disabled="isEditing"
                        @click="removeItem(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange"
                @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-confirm-activated" title="Aktivasi Flash Sale" centered no-close-on-backdrop no-close-on-esc
            hide-footer>
            <b-form-group label="Diskon Flash Sale (%)">
                <b-input-group append="%">
                    <b-input placeholder="Masukan Diskon Flash Sale" v-model="flashSale.discountPercentage" max="99"
                        min="1" />
                </b-input-group>
            </b-form-group>
            <div class="text-right mt-4">
                <b-button variant="primary" :disabled="isSubmitting" @click="execFlashSale">
                    Submit
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-add-item" title="Tambah Barang" size="lg" centered hide-footer no-close-on-backdrop
            no-close-on-esc>
            <div v-if="!hasItemData">
                <h3>{{ data.item.type }}</h3>
                <span>{{ data.item.kind }} - {{ data.item.brand }}</span>
                <div class="d-flex align-items-center my-1">
                    <b-badge class="mr-2" v-if="!data.item.is_valid_photo" variant="danger">
                        Foto fisik tidak lengkap
                    </b-badge>
                    <b-badge v-if="!data.item.is_valid_photo_adjustment" variant="danger">
                        Foto kerusakan tidak lengkap
                    </b-badge>
                </div>
                <b-row class="mt-2">
                    <b-col md="4">
                        <strong>No. Faktur</strong><br />
                        <span>{{ data.item.no_faktur }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>IMEI / SN</strong><br />
                        <span>{{ data.item.imei_sn }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Grade</strong><br />
                        <span>{{ data.item.grade }}</span>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <strong>Kelengkapan</strong><br />
                        <span>{{ data.item.is_batangan ? "Batangan" : "Lengkap" }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Spek</strong><br />
                        <span>{{ data.item.spec }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Gudang</strong><br />
                        <span>{{ data.item.warehouse }} - {{ data.item.office }}</span>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col md="4">
                        <strong>Harga</strong><br />
                        <span>Rp.{{ $helper.formatThousand(data.item.price) }}</span>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button :disabled="isSubmitting" variant="primary" class="mt-4" @click="addItem">
                            <i class="fa fa-check mr-2" />
                            Lanjutkan
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-confirm-finalize" title="Transaksikan Flash Sale" centered hide-footer no-close-on-backdrop
            no-close-on-esc>
            <b-form-group label="Transaksikan flash sale untuk...">
                <multiselect v-model="flashSale.customerId" label="name" track-by="id" :internal-search="true"
                    deselect-label="" select-label="" :options="optCustomer" />
                <small class="text-muted">
                    Setelah klik submit, sistem akan membuat invoice baru untuk flash sale ini.
                </small>
            </b-form-group>

            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="finalizeFlashSale">
                    Submit
                </b-button>
            </div>
        </b-modal>

    </div>
</template>

<script>

export default {
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isEditing: false,
            isBusy: false,
            hasItemData: true,

            data: {
                status: null,
                total_item: 0,
                division: "",
                items: [],
                item: {
                    type: "",
                    kind: "",
                    no_faktur: "",
                    imei_sn: "",
                    grade: "",
                    spec: "",
                    price: 0,
                    is_batangan: 0
                },
            },

            input: {
                noFaktur: ""
            },

            flashSale: {
                discountPercentage: null,
                customerId: null,
            },

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "no", label: "No." },
                { key: "barang", label: "Barang" },
                { key: "noFakturImei", label: "No. Faktur & IMEI / SN" },
                { key: "action", label: "Aksi" }
            ],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,
            optCustomer: [],

        }
    },

    methods: {

        init() {

            this.initStatus = 0

            let getData = this.getDetail()

            let getCustomers = this.$axios.get("customer/selection").then(res => {
                this.optCustomer = res.data.data
            })

            Promise.all([getData, getCustomers]).then(() => {
                this.initStatus = 1
            })
                .catch(err => {
                    console.log(err, "error init")
                    this.initStatus = -1
                })

        },

        getItem() {

            if (this.$helper.isBlank(this.input.noFaktur)) {
                return this.$helper.toastError(this, "Mohon mengisi nomor faktur!")
            }

            this.hasItemData = true

            this.$axios.get(`flash-sale/items/${this.input.noFaktur}`).then(res => {
                this.data.item = res.data.data
                this.hasItemData = false
                this.$bvModal.show("m-add-item")
            })
                .catch(error => this.$helper.parseError(this, error))

        },

        addItem() {

            this.isSubmitting = true
            const payload = {
                flash_sale_id: this.$route.params.id,
                inventory_id: this.data.item.id
            }

            this.$axios.post("flash-sale/items", payload).then(() => {
                this.$helper.toastSuccess(this, "Barang berhasil ditambahkan!")
                this.input.noFaktur = ""
                this.hasItemData = true
                this.isSubmitting = false
                this.$bvModal.hide("m-add-item")
                this.getDetail()
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        removeItem(item) {

            let confirmed = confirm(`Hapus ${item.type} (NF ${item.no_faktur_pgi}) dari flash sale ini?`)
            if (!confirmed) return

            let payload = {
                flash_sale_id: this.$route.params.id,
                inventory_id: item.inventory_id,
            }

            this.$axios.delete("flash-sale/items", {
                data: payload
            }).then(() => {
                this.$helper.toastSuccess(this, "Barang berhasil dihapus!")
                this.getDetail()
            })
                .catch(error => this.$helper.parseError(this, error))

        },

        cancelFlashSale() {
            let isConfirmed = confirm("Batalkan flash sale ini? Draft akan dihapus dan barang-barang akan dikembalikan ke status semula!")
            if (!isConfirmed) return

            this.$axios.delete(`flash-sale/${this.$route.params.id}`).then(() => {
                this.$router.push({ path: "/sales/flash-sale" })
            })
        },

        activatedFlashSale() {
            if (this.data.items.length == 0) {
                return this.$helper.toastError(this, "Belum ada barang di flash sale!")
            }

            this.$bvModal.show("m-confirm-activated")
        },

        openModalFinalize() {
            this.finalizeFlashSale.customerId = null;
            this.$bvModal.show("m-confirm-finalize");
        },


        execFlashSale() {

            if (this.$helper.isBlank(this.flashSale.discountPercentage) || this.flashSale.discountPercentage < 1 || this.flashSale.discountPercentage > 99) {
                return this.$helper.toastError(this, "Mohon mengisi diskon flash sale dengan benar!")
            }

            const payload = {
                discount_percentage: this.flashSale.discountPercentage
            }

            this.isSubmitting = true
            this.$axios.patch(`flash-sale/activate/${this.$route.params.id}`, payload).then(() => {
                this.$helper.toastSuccess(this, "Flash sale berhasil diaktifkan!")
                this.$bvModal.hide("m-confirm-activated")
                this.$router.push({ path: "/sales/flash-sale" })
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        getDetail(page) {
            this.isBusy = true

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            const params = {
                page: this.currentPage,
                per_page: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            }

            return this.$axios.get(`flash-sale/${this.$route.params.id}`, { params }).then(res => {
                this.data = res.data.data
                this.totalRows = res.data.data.details.total
                this.data.items = res.data.data.details.items.map(item => {
                    return {
                        id: item.id,
                        inventory_id: item.inventory_id,
                        kind: item.kind,
                        brand: item.brand,
                        type: item.type,
                        no_faktur_pgi: item.no_faktur,
                        price: item.price,
                        imei_sn: item.imei_sn,
                    }
                })
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => { this.isBusy = false })
        },

        nonActiveFlashSale() {
            let confirmed = confirm(`Non-aktifkan flash sale ini ?`)
            if (!confirmed) return

            this.isSubmitting = true

            const payload = {
                flash_sale_id: this.$route.params.id
            }

            this.$axios.patch(`flash-sale/deactivate`, payload).then(() => {
                this.$helper.toastSuccess(this, "Flash Sale berhasil dinonaktifkan!")
                this.$router.push({ path: "/sales/flash-sale" })
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        finalizeFlashSale() {

            if (this.$helper.isBlank(this.flashSale.customerId)) {
                return this.$helper.toastError(this, "Mohon memilih customer!")
            }

            this.isSubmitting = true;

            const payload = {
                customer_id: this.flashSale.customerId ? this.flashSale.customerId.id : null,
            }

            this.$axios.post(`flash-sale/finalize/${this.$route.params.id}`, payload).then(res => {
                const invoiceId = res.data.data.invoice_id;
                this.$helper.toastSuccess(this, "Flash Sale berhasil ditransaksikan!")
                this.$bvModal.hide("m-confirm-finalize")
                this.$router.push({ path: `/sales/invoice/draft/${invoiceId}` })
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getDetail(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getDetail(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getDetail()
        },
        getStatusBadge(status) {
            switch (status) {
                case 1: return ["dark", "DRAFT"]
                case 2: return ["primary", "AKTIF"]
                case 3: return ["success", "TERJUAL"]
                case 0: return ["danger", "TIDAK AKTIF"]
                default: return ["light", "-"]
            }
        },

    },
    computed: {
        filteredFields() {
            if (this.data.status !== 1) {
                return this.fields.filter(f => f.key !== "action");
            }
            return this.fields;
        }
    },
    created() {

        this.init()
    }
}
</script>

<style></style>
